/* AstroFlav Elevated PDP behaviour: plan toggle, selling-plan intervals, quantity. */
(function () {
  function initRoot(root) {
    if (root.dataset.elvInit === "true") return;
    root.dataset.elvInit = "true";

    var form = root.querySelector("#elv-product-form") || root.querySelector('form[action*="/cart/add"]');
    var planButtons = root.querySelectorAll("[data-elv-plan]");
    var intervalWrap = root.querySelector("[data-elv-intervals]");
    var intervalButtons = root.querySelectorAll("[data-elv-interval]");
    var sellingPlanInput = root.querySelector("[data-elv-selling-plan]");
    var submitLabel = root.querySelector("[data-elv-submit-label]");
    var qtyInput = root.querySelector("[data-elv-qty]");

    var priceSub = root.dataset.priceSub || "";
    var priceOnce = root.dataset.priceOnce || "";
    var addLabel = root.dataset.addLabel || "Add to cart";

    function currentInterval() {
      var active = root.querySelector('[data-elv-interval][aria-pressed="true"]');
      return active ? active.textContent.trim() : "";
    }

    function render() {
      var subActive =
        root.querySelector('[data-elv-plan="sub"]') &&
        root.querySelector('[data-elv-plan="sub"]').getAttribute("aria-pressed") === "true";

      if (intervalWrap) intervalWrap.hidden = !subActive;

      if (sellingPlanInput) {
        if (subActive) {
          var active = root.querySelector('[data-elv-interval][aria-pressed="true"]');
          sellingPlanInput.value = active ? active.dataset.planId || "" : "";
          sellingPlanInput.disabled = !sellingPlanInput.value;
        } else {
          sellingPlanInput.value = "";
          sellingPlanInput.disabled = true;
        }
      }

      if (submitLabel) {
        submitLabel.textContent = subActive
          ? addLabel + " — " + priceSub + (currentInterval() ? " / " + currentInterval().toLowerCase() : "")
          : addLabel + " — " + priceOnce;
      }
    }

    Array.prototype.forEach.call(planButtons, function (btn) {
      btn.addEventListener("click", function () {
        Array.prototype.forEach.call(planButtons, function (other) {
          other.setAttribute("aria-pressed", String(other === btn));
        });
        render();
      });
    });

    Array.prototype.forEach.call(intervalButtons, function (btn) {
      btn.addEventListener("click", function (event) {
        event.stopPropagation();
        Array.prototype.forEach.call(intervalButtons, function (other) {
          other.setAttribute("aria-pressed", String(other === btn));
        });
        render();
      });
    });

    root.querySelectorAll("[data-elv-qty-step]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!qtyInput) return;
        var step = parseInt(btn.dataset.elvQtyStep, 10) || 1;
        var next = (parseInt(qtyInput.value, 10) || 1) + step;
        qtyInput.value = String(Math.min(99, Math.max(1, next)));
      });
    });

    // Keep the sticky bar CTA wired to the real form.
    root.querySelectorAll("[data-elv-sticky-submit]").forEach(function (btn) {
      btn.addEventListener("click", function (event) {
        if (!form) return;
        event.preventDefault();
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else form.submit();
      });
    });

    render();
  }

  function init() {
    document.querySelectorAll("[data-elv-root]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  // Theme editor re-renders sections without a full page load.
  document.addEventListener("shopify:section:load", init);
})();
